import { auth } from '@/services';

angular.module('app')
    .service('Users', users);

users.$inject = [
    '$q',
    'modalService',
];

function users(
    $q,
    modalService,
) {
    /**
     * Opens a modal allowing a new user to be created
     * @param  {object} defaults - Set any default data for the new user
     * @return {PromiseLikeObject<void>}
     */
    function createUser(defaults) {
        const deferred = $q.defer();

        if (!auth.hasPermission('users.create')) {
            deferred.reject('Not authorised to create new user');
            return;
        }

        modalService.open({
            templateUrl: 'modals/manage-user.html',
            controller: 'manageUserController',
            controllerAs: 'vm',
            resolve: {
                userDefaults: () => defaults,
                userId: () => null,
            },
            windowClass: 'manage-user',
        }).result
            .then(deferred.resolve)
            .catch(deferred.reject);

        return deferred.promise;
    }

    /**
     * Opens a modal allowing a user to be edited
     * @param  {int} userId - ID of user to edit
     * @return {object}     - modalService object containing result.then()
     */
    function editUser(userId) {
        if (!userId) { return false; }

        return modalService.open({
            templateUrl: 'modals/manage-user.html',
            controller: 'manageUserController',
            controllerAs: 'vm',
            resolve: {
                userId: () => userId,
                userDefaults: () => null,
            },
            windowClass: 'manage-user',
        });
    }

    /**
     * Opens a modal allowing a message to be entered before sending a connection request to this user
     * @param  {int} userId - ID of user to send request to
     * @return {object}     - modalService object containing result.then()
     */
    function sendConnectRequest(userId) {
        if (!userId) { return false; }

        return modalService.open({
            templateUrl: 'modals/send-connect-request.html',
            controller: 'sendConnectRequestController',
            controllerAs: 'vm',
            resolve: {
                userId: () => userId,
            },
            windowClass: 'send-connect-request',
        });
    }

    /**
     * Cancels a connect request.
     * @param  {int} userId - ID of user to send request to
     * @return {object}     - modalService object containing result.then()
     */
    function cancelConnectRequest(connectRequestId) {
        if (!connectRequestId) { return false; }

        return modalService.open({
            templateUrl: 'modals/cancel-connect-request.html',
            controller: 'cancelConnectRequestController',
            controllerAs: 'vm',
            resolve: {
                connectRequestId: () => connectRequestId,
            },
            windowClass: 'cancel-connect-request',
        });
    }

    /**
     * Opens a modal allowing a message to sent to the specified user
     * @param  {int} userId - (optional) ID of user to message to. If undefined, the user will be able to search for someone
     * @return {object}     - modalService object containing result.then()
     */
    function sendMessage(userId) {
        return modalService.open({
            templateUrl: 'modals/send-message.html',
            controller: 'sendMessageController',
            controllerAs: 'vm',
            resolve: {
                userId: () => userId,
            },
            windowClass: 'send-message',
        });
    }

    /**
     * Opens a modal allowing this user to update their card details
     * @return {object} - modalService object containing result.then()
     */
    function manageCard(event) {
        return modalService.open({
            templateUrl: 'modals/manage-cards.html',
            controller: 'manageCardsController',
            controllerAs: 'vm',
            windowClass: 'manage-cards',
            resolve: {
                event: () => event,
            },
        });
    }

    return {
        create: createUser,
        edit: editUser,
        sendConnectRequest,
        sendMessage,
        manageCard,
        cancelConnectRequest,
    };
}
